"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorPairContext = exports.isDarkColor = exports.availableColors = exports.darkColors = exports.lightColors = exports.classes = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const Box_1 = __importDefault(require("@mui/material/Box"));
const styles_1 = require("@mui/material/styles");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const PREFIX = "ColorPair";
exports.classes = {
    root: `${PREFIX}-root`,
    white: `${PREFIX}-white`,
    pearl: `${PREFIX}-pearl`,
    storm: `${PREFIX}-storm`,
    blue100: `${PREFIX}-blue100`,
    magenta100: `${PREFIX}-magenta100`,
    aqua100: `${PREFIX}-aqua100`,
    orange100: `${PREFIX}-orange100`,
    alert: `${PREFIX}-alert`,
    alabaster: `${PREFIX}-alabaster`,
    black: `${PREFIX}-black`,
    charcoal: `${PREFIX}-charcoal`,
    slate: `${PREFIX}-slate`,
    blue800: `${PREFIX}-blue800`,
    blue900: `${PREFIX}-blue900`,
    teal400: `${PREFIX}-teal400`,
    teal500: `${PREFIX}-teal500`,
    magenta400: `${PREFIX}-magenta400`,
    magenta500: `${PREFIX}-magenta500`,
    purple400: `${PREFIX}-purple400`,
    orange500: `${PREFIX}-orange500`,
    error: `${PREFIX}-error`,
    secondary1: `${PREFIX}-secondary1`,
    secondary2: `${PREFIX}-secondary2`,
    secondary3: `${PREFIX}-secondary3`,
    secondary4: `${PREFIX}-secondary4`
};
const Root = (0, styles_1.styled)(Box_1.default)(({ theme }) => ({
    backgroundColor: theme.colours.white,
    color: theme.colours.charcoal,
    WebkitPrintColorAdjust: "exact",
    [`&.${exports.classes.white}`]: {
        backgroundColor: theme.colours.white,
        color: theme.colours.charcoal
    },
    [`&.${exports.classes.pearl}`]: {
        backgroundColor: theme.colours.pearl,
        color: theme.colours.charcoal
    },
    [`&.${exports.classes.storm}`]: {
        backgroundColor: theme.colours.storm,
        color: theme.colours.charcoal
    },
    [`&.${exports.classes.blue100}`]: {
        backgroundColor: theme.colours.blue100,
        color: theme.colours.charcoal
    },
    [`&.${exports.classes.magenta100}`]: {
        backgroundColor: theme.colours.magenta100,
        color: theme.colours.charcoal
    },
    [`&.${exports.classes.aqua100}`]: {
        backgroundColor: theme.colours.aqua100,
        color: theme.colours.charcoal
    },
    [`&.${exports.classes.orange100}`]: {
        backgroundColor: theme.colours.orange100,
        color: theme.colours.charcoal
    },
    [`&.${exports.classes.alert}`]: {
        backgroundColor: theme.colours.yellow400,
        color: theme.colours.charcoal
    },
    [`&.${exports.classes.alabaster}`]: {
        backgroundColor: theme.colours.alabaster,
        color: theme.colours.charcoal
    },
    [`&.${exports.classes.black}`]: {
        backgroundColor: theme.colours.black,
        color: theme.colours.white
    },
    [`&.${exports.classes.charcoal}`]: {
        backgroundColor: theme.colours.charcoal,
        color: theme.colours.white
    },
    [`&.${exports.classes.slate}`]: {
        backgroundColor: theme.colours.slate,
        color: theme.colours.white
    },
    [`&.${exports.classes.blue800}`]: {
        backgroundColor: theme.colours.blue800,
        color: theme.colours.white
    },
    [`&.${exports.classes.blue900}`]: {
        backgroundColor: theme.colours.blue900,
        color: theme.colours.white
    },
    [`&.${exports.classes.teal400}`]: {
        backgroundColor: theme.colours.teal400,
        color: theme.colours.white
    },
    [`&.${exports.classes.teal500}`]: {
        backgroundColor: theme.colours.teal500,
        color: theme.colours.white
    },
    [`&.${exports.classes.magenta400}`]: {
        backgroundColor: theme.colours.magenta400,
        color: theme.colours.white
    },
    [`&.${exports.classes.magenta500}`]: {
        backgroundColor: theme.colours.magenta500,
        color: theme.colours.white
    },
    [`&.${exports.classes.purple400}`]: {
        backgroundColor: theme.colours.purple400,
        color: theme.colours.white
    },
    [`&.${exports.classes.orange500}`]: {
        backgroundColor: theme.colours.orange500,
        color: theme.colours.white
    },
    [`&.${exports.classes.error}`]: {
        backgroundColor: theme.colours.error400,
        color: theme.colours.white
    },
    [`&.${exports.classes.secondary1}`]: {
        backgroundColor: theme.colours.secondary1,
        color: theme.colours.white
    },
    [`&.${exports.classes.secondary2}`]: {
        backgroundColor: theme.colours.secondary2,
        color: theme.colours.white
    },
    [`&.${exports.classes.secondary3}`]: {
        backgroundColor: theme.colours.secondary3,
        color: theme.colours.white
    },
    [`&.${exports.classes.secondary4}`]: {
        backgroundColor: theme.colours.secondary4,
        color: theme.colours.white
    }
}));
exports.lightColors = [
    "white",
    "alabaster",
    "pearl",
    "storm",
    "blue100",
    "magenta100",
    "aqua100",
    "orange100",
    "alert"
];
exports.darkColors = [
    "black",
    "charcoal",
    "slate",
    "blue800",
    "blue900",
    "teal400",
    "teal500",
    "magenta400",
    "magenta500",
    "purple400",
    "orange500",
    "error",
    "secondary1",
    "secondary2",
    "secondary3",
    "secondary4"
];
exports.availableColors = [...exports.lightColors, ...exports.darkColors];
const isDarkColor = (color) => {
    return !!color && exports.darkColors.includes(color);
};
exports.isDarkColor = isDarkColor;
exports.ColorPairContext = (0, react_1.createContext)({});
const ColorPair = react_1.default.forwardRef(({ color = "white", className, children, markupComponent: MarkupComponent = "div", ...rest }, ref) => {
    /* istanbul ignore next */
    if (process.env.NODE_ENV === "development" &&
        !exports.availableColors.includes(color)) {
        // eslint-disable-next-line no-console
        console.warn(`ColorPair: The color ${color} used doesn't exist in the CSS classes. Check there isn't any misalignment between TS and CSS. Available themes are ${exports.availableColors.join(", ")}`);
    }
    return ((0, jsx_runtime_1.jsx)(Root, { as: MarkupComponent, 
        /* eslint-disable-next-line security/detect-object-injection */
        className: (0, classnames_1.default)(className, exports.classes[color]), ref: ref, ...rest, children: (0, jsx_runtime_1.jsx)(exports.ColorPairContext.Provider, { value: { type: (0, exports.isDarkColor)(color) ? "dark" : "light", color }, children: children }) }));
});
ColorPair.displayName = "ColorPair";
exports.default = ColorPair;
//# sourceMappingURL=data:application/json;base64,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